<template>
  <HoverMenu :nudgeamount="-3" :direction="'top'">
    <template v-slot:menu-activator>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon :color="CurrentFlag.color" size="20" class="mx-2" v-text="CurrentFlag.icon" v-bind="attrs" v-on="on">
          </v-icon>
        </template>
        <span v-text="CurrentFlag.text" />
      </v-tooltip>
    </template>

    <template v-slot:menu-content>
      <QButtonGroup v-model="flag" :list="flagList" :edit="true" alwaysShowColor @change="e => setFlag(e)">
      </QButtonGroup>
    </template>
  </HoverMenu>

</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import HoverMenu from "@/components/Menus/HoverMenu.vue";

export default {
  name: "MachineFlag",
  props: {
    flagvalue: [String, Number],
    jobId: [String, Number],
    machineId: [String, Number],
  },
  components: {
    HoverMenu,
  },
  mixins: [clientAPI],

  data() {
    return {
      flag: null,
      flagList: [
        { value: null, color: "disabled", text: this.$t("servicesystem.common_objects.machine.no_flag"), icon: "mdi-flag" },
        { value: 0, color: "quaternary", text: this.$t("servicesystem.common_objects.machine.ok"), icon: "mdi-flag" },
        { value: 1, color: "#FFD262", text: this.$t("servicesystem.common_objects.machine.notice"), icon: "mdi-flag" },
        { value: 2, color: "#FF8073", text: this.$t("servicesystem.common_objects.machine.problem"), icon: "mdi-flag" },
      ],
    };
  },

  mounted() {
    this.flag = this.flagvalue;
  },

  methods: {
    setFlag(flag) {
      this.changeSubjobFlag(this.jobId, flag);
    },
  },

  computed: {
    CurrentFlag() {
      return this.flagList.find(x => x.value === this.flag);
    },
  },

  watch: {
    flagvalue: function () {
      this.flag = this.flagvalue;
    },
  },
};
</script>

<style lang="scss" scoped></style>